import { Tab } from '@headlessui/react';
import { Typography } from '../../molecules/Typography';
import Player from '../../molecules/Player';
import Comment from '../comment';
import { Modal } from '../../templates/Modal';
import { useResolutionModalHook } from '../../../hooks/resolutionModal';
import { IVideo } from '../../../models/video';
import { getResolutionVideoConfig } from '../../../utils/video';

interface IResolutionModal {
  resolutionVideo: IVideo;
  exerciseId?: string;
  isOpen: boolean;
  onClose: () => void;
}

export function ResolutionModal({
  resolutionVideo,
  exerciseId,
  onClose,
  isOpen,
}: IResolutionModal) {
  const { activeTab, changeTab } = useResolutionModalHook();

  const { playerType, token, fallbackToken } = getResolutionVideoConfig(resolutionVideo);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position='center'
      className='xs:w-full md:w-1/2'
      title='Resolução do exercício'
    >
      <div className='p-4'>
        <Tab.Group selectedIndex={activeTab} onChange={changeTab}>
          <Tab.List className='bg-white m-auto w-full rounded-pill border-hairline'>
            <Tab
              className={`w-1/2 rounded-l-pill py-2 ${
                activeTab === 0 && 'bg-brand-color-primary-pure'
              }`}
            >
              <Typography
                type='title'
                size='h4'
                className={`${activeTab === 0 && 'text-color-lightest'}`}
              >
                Resolução em video
              </Typography>
            </Tab>
            {exerciseId && (
              <Tab
                className={`w-1/2 rounded-r-pill py-2 ${
                  activeTab === 1 && 'bg-brand-color-primary-pure'
                }`}
              >
                <Typography
                  type='title'
                  size='h4'
                  className={`${activeTab === 1 && 'text-color-lightest'}`}
                >
                  Comentários
                </Typography>
              </Tab>
            )}
          </Tab.List>
          <Tab.Panels>
            <Tab.Panel className='p-4'>
              <Player
                onFinish={() => {}}
                token={token}
                fallbackToken={fallbackToken}
                playerType={playerType}
                initialTime={0}
                className='h-[48vh] w-full'
              />
            </Tab.Panel>
            {exerciseId && (
              <Tab.Panel className='pt-8'>
                <Comment
                  showTitle={false}
                  title='Comentários da videoaula'
                  targetId={exerciseId}
                  targetType='Exercise'
                />
              </Tab.Panel>
            )}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </Modal>
  );
}
